import { UcoastEl } from '@/scripts/core/UcoastEl'

export class CustomAccordion extends UcoastEl {
  static htmlSelector = 'custom-accordion'

  private accordions: NodeListOf<CustomAccordion>
  private details: HTMLDetailsElement

  constructor() {
    super()

    this.details = this.querySelector('details')

    // Scope: all accordions in same parent
    // this.accordions = this.parentElement?.querySelectorAll('custom-accordion') || []

    // this.details.addEventListener('toggle', () => {
    //   // Only act when THIS one is opened
    //   if (this.details.open) {
    //     this.accordions.forEach((accordion: any) => {
    //       if (accordion !== this) {
    //         accordion.details?.removeAttribute('open')
    //       }
    //     })
    //   }
    // })
  }
}